import GroupService from '@/service/group'
export default {
  getListGroup ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.getListGroup(payload.page, payload.per_page, payload.status).then(res => {
        commit('getListGroup', res.data.data)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  createGroup ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.createGroup(payload.group).then(res => {
        commit('createGroup', res.data.data)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  showGroup ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.showGroup(payload.group).then(res => {
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateGroup ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.updateGroup(payload.group).then(res => {
        commit('updateGroup', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  destroyGroup ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.destroyGroup(payload.group).then(res => {
        commit('destroyGroup', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  approvalGroup ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.approvalGroup(payload.group).then(res => {
        commit('updateGroup', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  rejectGroup ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      GroupService.rejectGroup(payload.group).then(res => {
        commit('updateGroup', res.data.data)
        resolve(res.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group/actions.js